import React, { useEffect, useState } from "react";
import { getSocialPersonalHistorySummary } from "../Helpers/API/ReportsApi/ReportsApi";
import { formatDateWithTime } from "../Helpers/Utilities/Common";
import { Table } from "antd";
import { useParams } from "react-router-dom";

export default function SocialPersonalHistorySummary({
  isVisible,
  setIsSelected,
  setIsMedicalHistory,
  setSelectedItem,
}) {
  const { id } = useParams();
  const [showLoader, setShowLoader] = useState(false);
  const [summary, setSummary] = useState([]);

  const handleRowClick = (record) => {
    setIsMedicalHistory(false);
    if (record.name === "Smoking Profile") {
      setIsSelected("Smoking");
      setSelectedItem(0);
    } else if (record.name === "Drinking Profile") {
      setIsSelected("Drinking");
      setSelectedItem(1);
    } else if (record.name === "Illicit Drug Use Profile") {
      setIsSelected("Illicit Drug Use");
      setSelectedItem(2);
    } else if (record.name === "Herbal Use Profile") {
      setIsSelected("Herbal Use");
      setSelectedItem(3);
    } else if (record.name === "Sexual Activity Profile") {
      setIsSelected("Sexual Activity");
      setSelectedItem(4);
    }
  };

  async function get() {
    setShowLoader(true);
    const res = await getSocialPersonalHistorySummary(id);

    if (res.data) {
      const allowed = [
        "Smoking Profile",
        "Drinking Profile",
        "Herbal Use Profile",
        "Drug Use Profile",
        "Sexual Activity Profile",
      ];

      const _parsed = res.data.data
        .filter((med) => allowed.includes(med.name))
        .map((med) => {
          return {
            ...med,
            added_on: formatDateWithTime(med.added_on),
          };
        });

      setSummary(_parsed);
    } else if (res.error) {
      setSummary([]);
    }
    setShowLoader(false);
  }

  useEffect(() => {
    get();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);
  return (
    <Table
      columns={[
        { title: "Social/Personal", dataIndex: "name" },
        { title: "Latest Date", dataIndex: "added_on" },
      ]}
      onRow={(record) => ({
        onClick: () => handleRowClick(record),
      })}
      dataSource={summary}
      size="small"
      loading={showLoader}
    />
  );
}
